export default __webpack_public_path__ + "static/media/tiktok.c38fd0d7.svg";